import { css } from '@linaria/core'
import { JSXElement, mergeProps } from 'solid-js'
import { zIndex } from '../frame'

export function MAOButton(props: {
  onClick: () => void
  floating?: boolean
  children?: JSXElement
}) {
  props = mergeProps({ floating: false }, props)

  return (
    <button
      id="OfferKit_make-an-offer"
      classList={{
        'OfferKit_make-an-offer': true,
        'button-override': true,
        [styles.button]: true,
        [styles.floating]: props.floating,
      }}
      onClick={props.onClick}
    >
      {props.children ?? 'Make an offer'}
    </button>
  )
}

const height = 56 // px

const styles = {
  button: css`
    height: ${height}px;
    min-width: 184px;
    padding: 0 ${height / 2}px;
    border: 0;
    border-radius: ${height / 2}px;
    background: #000;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    text-align: center;
    white-space: nowrap;
    outline: none;
    cursor: pointer;
    transition: 0.2s bottom ease-out, 0.2s filter ease-out;

    &:hover {
      filter: brightness(0.8);
    }
  `,
  floating: css`
    @keyframes fade-in {
      from {
        opacity: 0;
        visibility: hidden;
        transform: translate(-50%, 33.33%);
      }
      to {
        opacity: 1;
        visibility: visible;
        transform: translate(-50%, 0);
      }
    }

    z-index: ${Math.min(
      Math.max(0, 2147483644 - 1),
      zIndex + 1
    )}; // Clamp the z-index bellow the commonly found Facebook Chat plugin and Propps's modal
    box-shadow: 0 16px 32px 0 rgba(0, 0, 0, 0.2);
    position: fixed;
    bottom: 24px;
    left: 50%;
    animation: 0.3s ease-out 1s fade-in both;
  `,
}
